/**
 * To prevent the security and scale issues arising from match-all Express
 * routes, the Wallet app needs to match only URLs that are known routes
 * handled by the Backbone app. However, a routed Express app and a routed
 * Backbone app need to maintain their routes in slightly different formats.
 * routeTable(universal, clientOnly, serverOnly) returns an object with an
 * .express property for server-side Express routes, and a .backbone property
 * for client-side Backbone routes, generated from the same data.
 *
 * @param universal -- An object of Backbone routes, with keys as route
 * matchers and values as router method names.
 * @param clientOnly -- An object of Backbone routes that we will not try to
 * expressify. This could be due to routing logic that doesn't translate to
 * the server, or because it doesn't need to be routed.
 * @param serverOnly -- An array of Express route matchers that will not be
 * routed by the Backbone router. If you need to hand-write simple Express
 * matchers to handle complex Backbone routes, here is where the matchers
 * would go.
 *
 * Returns a tuple { express, backbone }. `backbone` is an object of Backbone
 * routes, consisting of the merged `universal` and `clientOnly` routes
 * supplied. `express` is an array of Express matchers. The expected usage
 * is for Express to route all those matchers to the same server-side handler,
 * which just renders the Backbone app and allows it to do client-side routing
 * on page load.

/**
 * Backbone.Router syntax denotes "optional" route segments with parentheses,
 * e.g. 'bank(/:id)'. Express.Router denotes the same thing with a ? instead,
 * e.g. 'bank/:id?'. This naive function replaces one with the other.
 * It will still be necessary to take complex Backbone routes, put them in the
 * clientOnly table, and handwrite an Express equivalent.
 */
function expressify(route) {
	return route.replace(/\(([^)]+)\)/g, '$1?');
}

module.exports = function routeTable(universal, clientOnly, serverOnly) {
	return {
		backbone: Object.assign({}, universal, clientOnly),
		express: Object.keys(universal).concat(serverOnly).map(expressify)
	};
};



//////////////////
// WEBPACK FOOTER
// ./routes/table.js
// module id = 865
// module chunks = 0